import React, { useContext, useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { TextInput } from '@wfp/ui';
import { Editor as TinyMCEEditor } from 'tinymce';

import { type Country, type Section, Topic } from '../../restapi/types';
import { loadCountries } from '../../restapi/section';
import { opUpdatesContext, setCopyToContent, setOpUpdatesCountries } from './OperationalUpdatesStateProvider';
import { richTextForUpdate } from './OpUpdatesCountry';
import { traceOpUpdateUsage } from '../../restapi/document';
import { RichTextEditor } from '../common/RichTextEditor';


interface Props {
	section: Section;
	disabled?: boolean;
	onChange: (changes: Partial<Section>) => void;
}

export function SectionForm({section: sec, disabled, onChange}: Props) {
	const dispatch = useContext(opUpdatesContext).dispatch;
	const [subtitle, setSubtitle] = useState(sec.subtitle || '');
	const [countries, setCountries] = useState(sec.countries);
	const [editor, setEditor] = useState<TinyMCEEditor>();

	const showContentOnly = sec.topic === Topic.highlights;

	// Set countries on context (initially and on each change)
	useEffect(() => {
		dispatch(setOpUpdatesCountries(countries));
	}, [dispatch, countries]);

	// Set copy to content on context for opUpdates
	useEffect(() => {
		dispatch(setCopyToContent(u => {
			editor?.setContent(editor?.getContent() + '\n' + richTextForUpdate(u));
			traceOpUpdateUsage(sec, u);
		}));
	}, [dispatch, sec, editor]);

	return (
		<div>
			{!showContentOnly && (
				<>
					<h4 className="color-primary">{sec.title}</h4>
					<TextInput
						id="input-subtitle"
						disabled={disabled}
						value={subtitle}
						placeholder="Write a source here"
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							setSubtitle(e.target.value);
							onChange({subtitle: e.target.value});
						}}
					/>

					<h4 className="mt2 color-primary">Countries</h4>
					<AsyncSelect
						isDisabled={disabled}
						className="wfp--react-select-container"
						classNamePrefix="wfp--react-select"
						isMulti
						cacheOptions
						loadOptions={loadCountries}
						getOptionValue={(c: Country) => '' + c.pk}
						getOptionLabel={(c: Country) => c.name}
						value={countries}
						onChange={v => {
							const countries = v as Country[];
							setCountries(countries);
							onChange({countries: countries});
						}}

						menuPortalTarget={document.body}
						styles={{menuPortal: base => ({...base, zIndex: 9999})}}
					/>
				</>)
			}

			<h4 className="mt2 color-primary">Content</h4>
			<div className="dedob-document edit">
				<RichTextEditor
					disabled={disabled}
					initialValue={sec.content}
					onChange={text => {
						// setContent(text);
						onChange({content: text});
					}}
					onInit={(e) => setEditor(e)}
				/>
			</div>
		</div>
	);
}